module.exports = {"id":"234624","name":"Bakaye Dibassy","rating":"71","photo":"./data/images/photos/0/234624.png","club":{"name":"Amiens SC","logo":"./data/images/clubs/AmiensSC.png"},"positions":["DG","DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BakayeDibassy0.json
// module id = 525
// module chunks = 0